export const formFilterValuesInit = {
    name: '',
    profileName: ''
}

export type FormFilterFieldsType = typeof formFilterValuesInit;